"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Template Builder Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.21
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateBuilderApi = exports.TemplateBuilderApiFactory = exports.TemplateBuilderApiFp = exports.TemplateBuilderApiAxiosParamCreator = exports.TemplateType = exports.TemplateStatus = exports.TemplateMode = exports.TemplateDocumentType = exports.TemplateAutoGenerateRuleEvent = exports.DocumentResourcesType = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DocumentResourcesType = {
    Shipment: 'SHIPMENT',
    FreightInvoice: 'FREIGHT_INVOICE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TemplateAutoGenerateRuleEvent = {
    ShipmentCreated: 'shipment.created',
    ShipmentCarrierAssigned: 'shipment.carrier_assigned',
    FreightInvoiceReceived: 'freight_invoice.received'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TemplateDocumentType = {
    AdvanceRequest: 'ADVANCE_REQUEST',
    Authority: 'AUTHORITY',
    Bol: 'BOL',
    CarrierInvoiceOrBillingStatement: 'CARRIER_INVOICE_OR_BILLING_STATEMENT',
    CertificateOfOrigin: 'CERTIFICATE_OF_ORIGIN',
    Claim: 'CLAIM',
    Comcheck: 'COMCHECK',
    CommercialInvoice: 'COMMERCIAL_INVOICE',
    CustomerInvoice: 'CUSTOMER_INVOICE',
    CustomerTender: 'CUSTOMER_TENDER',
    CustomsClearanceRequest: 'CUSTOMS_CLEARANCE_REQUEST',
    CustomsEntrySummary: 'CUSTOMS_ENTRY_SUMMARY',
    CustomsPaperwork: 'CUSTOMS_PAPERWORK',
    DeliveryOrder: 'DELIVERY_ORDER',
    DeliveryReceipt: 'DELIVERY_RECEIPT',
    DetentionApproval: 'DETENTION_APPROVAL',
    DriverForm: 'DRIVER_FORM',
    ExitPass: 'EXIT_PASS',
    FactorInvoiceOrBillingStatement: 'FACTOR_INVOICE_OR_BILLING_STATEMENT',
    Fine: 'FINE',
    Fuel: 'FUEL',
    Hos: 'HOS',
    HouseAirwayBill: 'HOUSE_AIRWAY_BILL',
    HouseBillOfLading: 'HOUSE_BILL_OF_LADING',
    InspectionCertificate: 'INSPECTION_CERTIFICATE',
    Insurance: 'INSURANCE',
    InventoryRelease: 'INVENTORY_RELEASE',
    Invoice: 'INVOICE',
    LetterOfAssignment: 'LETTER_OF_ASSIGNMENT',
    Lumper: 'LUMPER',
    MasterAirwayBill: 'MASTER_AIRWAY_BILL',
    MasterBillOfLading: 'MASTER_BILL_OF_LADING',
    NmfcCertificate: 'NMFC_CERTIFICATE',
    NoticeOfAssignment: 'NOTICE_OF_ASSIGNMENT',
    NoticeOfRelease: 'NOTICE_OF_RELEASE',
    Other: 'OTHER',
    OveragesShortagesAndDamages: 'OVERAGES_SHORTAGES_AND_DAMAGES',
    PackingSlip: 'PACKING_SLIP',
    PackingSlips: 'PACKING_SLIPS',
    PalletReceipt: 'PALLET_RECEIPT',
    Pod: 'POD',
    RateConfirmation: 'RATE_CONFIRMATION',
    RenditionInvoicePacket: 'RENDITION_INVOICE_PACKET',
    ShippingLabel: 'SHIPPING_LABEL',
    Signature: 'SIGNATURE',
    TollReceipt: 'TOLL_RECEIPT',
    W9: 'W9',
    WashReceipt: 'WASH_RECEIPT',
    Waybill: 'WAYBILL',
    WeightCertificate: 'WEIGHT_CERTIFICATE',
    WeightTicketUnloaded: 'WEIGHT_TICKET_UNLOADED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TemplateMode = {
    Ftl: 'FTL',
    Ltl: 'LTL',
    Vltl: 'VLTL',
    Drayage: 'DRAYAGE',
    Intermodal: 'INTERMODAL',
    Parcel: 'PARCEL',
    RailCar: 'RAIL_CAR'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TemplateStatus = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TemplateType = {
    Document: 'DOCUMENT'
};
/**
 * TemplateBuilderApi - axios parameter creator
 * @export
 */
var TemplateBuilderApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Bulk Generate Documents From Templates
         * @param {BulkGenerateDocument} bulkGenerateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGenerateDocumentsFromTemplates: function (bulkGenerateDocument, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bulkGenerateDocument' is not null or undefined
                            (0, common_1.assertParamExists)('bulkGenerateDocumentsFromTemplates', 'bulkGenerateDocument', bulkGenerateDocument);
                            localVarPath = "/templates/bulk-generate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkGenerateDocument, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate Document From Template
         * @param {string} templateId
         * @param {GenerateDocument} generateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDocumentFromTemplate: function (templateId, generateDocument, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('generateDocumentFromTemplate', 'templateId', templateId);
                            // verify required parameter 'generateDocument' is not null or undefined
                            (0, common_1.assertParamExists)('generateDocumentFromTemplate', 'generateDocument', generateDocument);
                            localVarPath = "/templates/{template_id}/generate"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generateDocument, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Templates
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [q]
         * @param {string} [orderBy]
         * @param {string} [id]
         * @param {string} [name]
         * @param {TemplateStatus} [status]
         * @param {TemplateType} [templateType]
         * @param {TemplateDocumentType} [documentType]
         * @param {string} [allowedModesIn]
         * @param {string} [externalTagsIn]
         * @param {boolean} [includeInEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: function (page, limit, q, orderBy, id, name, status, templateType, documentType, allowedModesIn, externalTagsIn, includeInEmail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/templates";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (orderBy !== undefined) {
                                localVarQueryParameter['order_by'] = orderBy;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (templateType !== undefined) {
                                localVarQueryParameter['template_type'] = templateType;
                            }
                            if (documentType !== undefined) {
                                localVarQueryParameter['document_type'] = documentType;
                            }
                            if (allowedModesIn !== undefined) {
                                localVarQueryParameter['allowed_modes__in'] = allowedModesIn;
                            }
                            if (externalTagsIn !== undefined) {
                                localVarQueryParameter['external_tags__in'] = externalTagsIn;
                            }
                            if (includeInEmail !== undefined) {
                                localVarQueryParameter['include_in_email'] = includeInEmail;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Template Data Fields Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateDataFieldsSchema: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/templates/data_fields/schema";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Template Editor
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateEditor: function (templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('templateEditor', 'templateId', templateId);
                            localVarPath = "/templates/{template_id}/editor"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Template
         * @param {string} templateId
         * @param {UpdateTemplate} updateTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate: function (templateId, updateTemplate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('updateTemplate', 'templateId', templateId);
                            // verify required parameter 'updateTemplate' is not null or undefined
                            (0, common_1.assertParamExists)('updateTemplate', 'updateTemplate', updateTemplate);
                            localVarPath = "/templates/{template_id}"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateTemplate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TemplateBuilderApiAxiosParamCreator = TemplateBuilderApiAxiosParamCreator;
/**
 * TemplateBuilderApi - functional programming interface
 * @export
 */
var TemplateBuilderApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TemplateBuilderApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Bulk Generate Documents From Templates
         * @param {BulkGenerateDocument} bulkGenerateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGenerateDocumentsFromTemplates: function (bulkGenerateDocument, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkGenerateDocumentsFromTemplates(bulkGenerateDocument, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateBuilderApi.bulkGenerateDocumentsFromTemplates']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate Document From Template
         * @param {string} templateId
         * @param {GenerateDocument} generateDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDocumentFromTemplate: function (templateId, generateDocument, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateDocumentFromTemplate(templateId, generateDocument, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateBuilderApi.generateDocumentFromTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Templates
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [q]
         * @param {string} [orderBy]
         * @param {string} [id]
         * @param {string} [name]
         * @param {TemplateStatus} [status]
         * @param {TemplateType} [templateType]
         * @param {TemplateDocumentType} [documentType]
         * @param {string} [allowedModesIn]
         * @param {string} [externalTagsIn]
         * @param {boolean} [includeInEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: function (page, limit, q, orderBy, id, name, status, templateType, documentType, allowedModesIn, externalTagsIn, includeInEmail, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listTemplates(page, limit, q, orderBy, id, name, status, templateType, documentType, allowedModesIn, externalTagsIn, includeInEmail, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateBuilderApi.listTemplates']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Template Data Fields Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateDataFieldsSchema: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templateDataFieldsSchema(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateBuilderApi.templateDataFieldsSchema']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Template Editor
         * @param {string} templateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateEditor: function (templateId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.templateEditor(templateId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateBuilderApi.templateEditor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Template
         * @param {string} templateId
         * @param {UpdateTemplate} updateTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate: function (templateId, updateTemplate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTemplate(templateId, updateTemplate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TemplateBuilderApi.updateTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.TemplateBuilderApiFp = TemplateBuilderApiFp;
/**
 * TemplateBuilderApi - factory interface
 * @export
 */
var TemplateBuilderApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TemplateBuilderApiFp)(configuration);
    return {
        /**
         *
         * @summary Bulk Generate Documents From Templates
         * @param {TemplateBuilderApiBulkGenerateDocumentsFromTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGenerateDocumentsFromTemplates: function (requestParameters, options) {
            return localVarFp.bulkGenerateDocumentsFromTemplates(requestParameters.bulkGenerateDocument, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Generate Document From Template
         * @param {TemplateBuilderApiGenerateDocumentFromTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDocumentFromTemplate: function (requestParameters, options) {
            return localVarFp.generateDocumentFromTemplate(requestParameters.templateId, requestParameters.generateDocument, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Templates
         * @param {TemplateBuilderApiListTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.listTemplates(requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.orderBy, requestParameters.id, requestParameters.name, requestParameters.status, requestParameters.templateType, requestParameters.documentType, requestParameters.allowedModesIn, requestParameters.externalTagsIn, requestParameters.includeInEmail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Template Data Fields Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateDataFieldsSchema: function (options) {
            return localVarFp.templateDataFieldsSchema(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Template Editor
         * @param {TemplateBuilderApiTemplateEditorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateEditor: function (requestParameters, options) {
            return localVarFp.templateEditor(requestParameters.templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Template
         * @param {TemplateBuilderApiUpdateTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate: function (requestParameters, options) {
            return localVarFp.updateTemplate(requestParameters.templateId, requestParameters.updateTemplate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TemplateBuilderApiFactory = TemplateBuilderApiFactory;
/**
 * TemplateBuilderApi - object-oriented interface
 * @export
 * @class TemplateBuilderApi
 * @extends {BaseAPI}
 */
var TemplateBuilderApi = /** @class */ (function (_super) {
    __extends(TemplateBuilderApi, _super);
    function TemplateBuilderApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Bulk Generate Documents From Templates
     * @param {TemplateBuilderApiBulkGenerateDocumentsFromTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateBuilderApi
     */
    TemplateBuilderApi.prototype.bulkGenerateDocumentsFromTemplates = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateBuilderApiFp)(this.configuration).bulkGenerateDocumentsFromTemplates(requestParameters.bulkGenerateDocument, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Generate Document From Template
     * @param {TemplateBuilderApiGenerateDocumentFromTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateBuilderApi
     */
    TemplateBuilderApi.prototype.generateDocumentFromTemplate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateBuilderApiFp)(this.configuration).generateDocumentFromTemplate(requestParameters.templateId, requestParameters.generateDocument, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Templates
     * @param {TemplateBuilderApiListTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateBuilderApi
     */
    TemplateBuilderApi.prototype.listTemplates = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TemplateBuilderApiFp)(this.configuration).listTemplates(requestParameters.page, requestParameters.limit, requestParameters.q, requestParameters.orderBy, requestParameters.id, requestParameters.name, requestParameters.status, requestParameters.templateType, requestParameters.documentType, requestParameters.allowedModesIn, requestParameters.externalTagsIn, requestParameters.includeInEmail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Template Data Fields Schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateBuilderApi
     */
    TemplateBuilderApi.prototype.templateDataFieldsSchema = function (options) {
        var _this = this;
        return (0, exports.TemplateBuilderApiFp)(this.configuration).templateDataFieldsSchema(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Template Editor
     * @param {TemplateBuilderApiTemplateEditorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateBuilderApi
     */
    TemplateBuilderApi.prototype.templateEditor = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateBuilderApiFp)(this.configuration).templateEditor(requestParameters.templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Template
     * @param {TemplateBuilderApiUpdateTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateBuilderApi
     */
    TemplateBuilderApi.prototype.updateTemplate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateBuilderApiFp)(this.configuration).updateTemplate(requestParameters.templateId, requestParameters.updateTemplate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TemplateBuilderApi;
}(base_1.BaseAPI));
exports.TemplateBuilderApi = TemplateBuilderApi;
